import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const QueryExplorer = lazy(() => import('./pages/QueryExplorer'));

export const queriesRoutes: RouteObject = {
  path: 'queries',
  handle: { breadcrumb: 'Query Explorer' },
  children: [{ index: true, element: <QueryExplorer />, handle: { breadcrumb: 'Explorer' } }],
};
